// extracted by mini-css-extract-plugin
export default {"logo":"HeaderLogo-module__[local]___5-TGS"};